import { useQuery } from '@tanstack/react-query';
import { getClippedCoupons, isAuthenticated } from '../api/coupons';
import type { Coupon } from '../types/coupons';

function isExpired(coupon: Coupon): boolean {
  if (!coupon.expirationDate) return false;
  const exp = new Date(coupon.expirationDate);
  return !isNaN(exp.getTime()) && exp < new Date();
}

export function useClippedCoupons() {
  return useQuery<Coupon[]>({
    queryKey: ['clipped-coupons'],
    queryFn: async () => {
      const response = await getClippedCoupons();
      return response.items.filter((c) => !isExpired(c));
    },
    enabled: isAuthenticated(),
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
